import React, { type ReactNode, useContext, useMemo } from 'react';

import {
	RelayEnvironmentProvider as DefaultProvider,
	type IEnvironmentProvider,
	ReactRelayContext,
	useRelayEnvironment,
} from 'react-relay';
import { Environment, type IEnvironment } from 'relay-runtime';

import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';

const environment: IEnvironment = new Environment(getDefaultRelayEnvironmentConfig({}));

export const RelayEnvironmentProvider = ({ children }: { children: ReactNode }) => {
	return <DefaultProvider environment={environment}>{children}</DefaultProvider>;
};

export const ConditionalRelayEnvironmentProvider = ({ children }: { children: ReactNode }) => {
	const isRelayPresent = useContext(ReactRelayContext);

	if (isRelayPresent) {
		return children;
	}

	return <RelayEnvironmentProvider>{children}</RelayEnvironmentProvider>;
};

export function useRelayEnvironmentProvider(): IEnvironmentProvider<{}> {
	const environment = useRelayEnvironment();

	return useMemo(
		() => ({
			getEnvironment() {
				return environment;
			},
		}),
		[environment],
	);
}
